import * as Types from './types';

export default {
    [Types.REQUEST_LOGIN](state, payload) {
        state.app.loading = true;
    },

    [Types.SUCCESS_LOGIN](state, payload) {
        state.app.loading = false;
        state.auth = payload;
        state.app.companySelected = payload.user.empresas[0] || null;
    },

    [Types.FAILURE_LOGIN](state, payload) {
        state.app.loading = false;
        state.auth = null;
    },

    [Types.REQUEST_LOGOUT](state, payload) {
        state.auth = null;
        state.app.companySelected = null;
        state.app.loading = false;
    },

    [Types.SET_COMPANY_SELECTED](state, payload) {
        state.app.companySelected = payload;
    },

    [Types.APP_LOADING](state) {
        state.app.loading = !state.app.loading;
    }
};
